<mat-form-field>
    <mat-select [formControl]="control" class="user-type-selector" mat-select placeholder="User type">
        <mat-option value="student">Student</mat-option>
        <mat-option value="teacher">Teacher</mat-option>
    </mat-select>
</mat-form-field>
